// Wishlist Button Custom Element
if (!customElements.get('wishlist-button')) {
  customElements.define(
    'wishlist-button',
    class WishlistButton extends HTMLButtonElement {
      constructor() {
        super();
        
        this.addEventListener('click', this.toggleWishlist.bind(this));
        this.initialize();
      }
      
      get productId() {
        return this.getAttribute('data-product-id');
      }
      
      get productHandle() {
        return this.getAttribute('data-product-handle');
      }
      
      get productTitle() {
        return this.getAttribute('data-product-title');
      }
      
      get productPrice() {
        return this.getAttribute('data-product-price');
      }
      
      get productImage() {
        return this.getAttribute('data-product-image');
      }
      
      initialize() {
        // Check if product is in wishlist
        const wishlist = this.getWishlist();
        const inWishlist = wishlist.some(item => item.id === this.productId);
        
        if (inWishlist) {
          this.setAttribute('data-in-wishlist', '');
        } else {
          this.removeAttribute('data-in-wishlist');
        }
      }
      
      toggleWishlist() {
        const wishlist = this.getWishlist();
        const existingIndex = wishlist.findIndex(item => item.id === this.productId);
        
        if (existingIndex >= 0) {
          // Remove from wishlist
          wishlist.splice(existingIndex, 1);
          this.removeAttribute('data-in-wishlist');
          this.showToast('Product removed from wishlist');
        } else {
          // Add to wishlist
          wishlist.push({
            id: this.productId,
            handle: this.productHandle,
            title: this.productTitle,
            price: this.productPrice,
            image: this.productImage,
            added: new Date().toISOString()
          });
          this.setAttribute('data-in-wishlist', '');
          this.showToast('Product added to wishlist');
        }
        
        this.saveWishlist(wishlist);
        this.dispatchWishlistEvent();
      }
      
      getWishlist() {
        const wishlistJson = localStorage.getItem('shopify_wishlist') || '[]';
        try {
          return JSON.parse(wishlistJson);
        } catch (e) {
          return [];
        }
      }
      
      saveWishlist(wishlist) {
        localStorage.setItem('shopify_wishlist', JSON.stringify(wishlist));
      }
      
      dispatchWishlistEvent() {
        const inWishlist = this.hasAttribute('data-in-wishlist');
        document.dispatchEvent(new CustomEvent('wishlist:updated', {
          detail: {
            productId: this.productId,
            inWishlist,
            wishlist: this.getWishlist()
          }
        }));
      }
      
      showToast(message) {
        // Simple toast notification
        if (window.theme && window.theme.showToast) {
          window.theme.showToast(message);
        } else {
          // Fallback simple toast
          const toast = document.createElement('div');
          toast.classList.add('wishlist-toast');
          toast.textContent = message;
          toast.style.cssText = 'position:fixed;bottom:20px;left:50%;transform:translateX(-50%);background:rgba(0,0,0,0.8);color:white;padding:10px 20px;border-radius:4px;z-index:9999;font-size:14px;';
          document.body.appendChild(toast);
          
          setTimeout(() => {
            toast.style.opacity = '0';
            toast.style.transition = 'opacity 0.3s ease';
            setTimeout(() => toast.remove(), 300);
          }, 2000);
        }
      }
    },
    { extends: 'button' }
  );
}

// Product Card Functionality - CLEAN WORKING VERSION
document.addEventListener('DOMContentLoaded', () => {
  // Initialize product cards on page load
  initializeProductCards();
  
  // Remove sale badge initialization - now handled in Liquid
  // initializeSaleBadges();
  
  // Debug: Check if cards have the right structure
  const productCards = document.querySelectorAll('.product-card');
  
  productCards.forEach((card, index) => {
    const swatches = card.querySelectorAll('.content-swatch-item, .color-swatch.content-swatch-item');
    const dropdown = card.querySelector('.variant-select');
    const image = card.querySelector('.product-card-image');
    
    // Check swatch data
    swatches.forEach((swatch, swatchIndex) => {
    });
    
    // Check dropdown options
    if (dropdown) {
      Array.from(dropdown.options).forEach((option, optionIndex) => {
        if (option.value) {
        }
      });
    }
  });    // Content Swatch functionality (in the content area) - SCOPED TO PRODUCT CARDS ONLY
  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.content-swatch-item, .color-swatch.content-swatch-item');
    if (!swatch) return;

    // IMPORTANT: Only handle swatches that are inside product cards, not product pages
    const productCard = swatch.closest('.product-card');
    if (!productCard) {
      return;
    }
    
    // CRITICAL: Skip complementary product cards to prevent conflicts
    const isComplementaryCard = swatch.closest('.complementary-products');
    if (isComplementaryCard) {
      console.log('🔍 Skipping complementary product swatch - handled by complementary script');
      return;
    }
    
    // More specific check: Skip only if this is the main product's variant picker area
    // Allow product cards (like related products) to work even on product pages
    const isMainProductVariantPicker = swatch.closest('.product-form__input, .product__info .variant-picker, [data-product-form]:not(.product-card)');
    if (isMainProductVariantPicker) {
      return;
    }
    
    // Check if swatch is sold out
    if (swatch.classList.contains('sold-out') || swatch.hasAttribute('data-sold-out')) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    
    event.preventDefault();
    event.stopPropagation();
      // Update active state for content swatches
    productCard.querySelectorAll('.content-swatch-item, .color-swatch.content-swatch-item').forEach(s => {
      s.classList.remove('active');
    });
    swatch.classList.add('active');
    
    // Update variant ID in form (CRITICAL for quick add)
    const variantId = swatch.getAttribute('data-variant-id');
    const variantInput = productCard.querySelector('.product-variant-id');
    
    if (variantInput && variantId) {
      variantInput.value = variantId;
    }
      // Update image
    const productImage = productCard.querySelector('.product-card-image');
    const newImageSrc = swatch.dataset.variantImage;
    
    if (productImage && newImageSrc && newImageSrc !== productImage.src) {
      productImage.style.opacity = '0.5';
      productImage.onload = () => {
        productImage.style.opacity = '1';
      };
      productImage.onerror = () => {
        productImage.style.opacity = '1';
      };
      productImage.src = newImageSrc;
      if (swatch.dataset.variantSrcset) {
        productImage.srcset = swatch.dataset.variantSrcset;
      }
    }
    
    // Update add to cart button state
    updateAddToCartButton(productCard, variantId);
  });
  
  // Dropdown functionality
  document.addEventListener('change', (event) => {
    if (!event.target.classList.contains('variant-select')) return;
    
    const select = event.target;
    const productCard = select.closest('.product-card');
    
    // CRITICAL: Skip complementary product cards
    const isComplementaryCard = select.closest('.complementary-products');
    if (isComplementaryCard) {
      console.log('🔍 Skipping complementary product dropdown - handled by complementary script');
      return;
    }
    
    if (!productCard || !select.value) {
      return;
    }
    
    const selectedOption = select.options[select.selectedIndex];
    
    // Check if selected variant is sold out
    const isSoldOut = selectedOption.hasAttribute('disabled') || 
                     selectedOption.hasAttribute('data-sold-out') ||
                     selectedOption.textContent.toLowerCase().includes('sold out');
    
    if (isSoldOut) {
      // Reset to empty option
      select.value = '';
      return;
    }
    
    const variantInput = productCard.querySelector('.product-variant-id');
    
    if (variantInput) {
      variantInput.value = select.value;
    }
      // Update image
    const productImage = productCard.querySelector('.product-card-image');
    const newImageSrc = selectedOption.dataset.variantImage;
    
    if (productImage && newImageSrc && newImageSrc !== productImage.src) {
      productImage.style.opacity = '0.5';
      productImage.onload = () => {
        productImage.style.opacity = '1';
      };
      productImage.onerror = () => {
        productImage.style.opacity = '1';
      };
      productImage.src = newImageSrc;
      if (selectedOption.dataset.variantSrcset) {
        productImage.srcset = selectedOption.dataset.variantSrcset;
      }
    }
    
    // Update price
    const priceWrapper = productCard.querySelector('.price-wrapper');
    if (priceWrapper && selectedOption.dataset.variantPrice) {
      if (selectedOption.dataset.variantComparePrice) {
        priceWrapper.innerHTML = `
          <span class="price price--sale">
            <span class="price__current">${selectedOption.dataset.variantPrice}</span>
            <s class="price__compare">${selectedOption.dataset.variantComparePrice}</s>
          </span>
        `;
      } else {
        priceWrapper.innerHTML = `
          <span class="price">
            <span class="price__current">${selectedOption.dataset.variantPrice}</span>
          </span>
        `;
      }
      
      // Remove sale badge update - now handled in Liquid
      // updateSaleBadge(productCard);
    }
    
    // Update add to cart button state
    updateAddToCartButton(productCard, select.value);
  });
});

// Initialize product cards function
function initializeProductCards() {
  document.querySelectorAll('.product-card').forEach(productCard => {
    initializeProductCard(productCard);
  });
}

// Initialize individual product card
function initializeProductCard(productCard) {
  // Set up any individual card initialization here
  // For now, this just ensures the card is ready for interaction
  const productId = productCard.dataset.productId;
  if (productId) {
  }
}

// Update add to cart button based on variant availability
function updateAddToCartButton(productCard, variantId) {
  const addToCartButton = productCard.querySelector('.cart-bag-button, [type="submit"]');
  if (!addToCartButton) {
    return;
  }

  // Check if variant is available - Updated for new structure
  function checkVariantAvailability(productCard, variantId) {
    if (!variantId) return false;
    // Check content swatch availability
    const swatch = productCard.querySelector(`.content-swatch-item[data-variant-id="${variantId}"]`);
    if (swatch && (swatch.hasAttribute('data-sold-out') || swatch.classList.contains('sold-out'))) {
      return false;
    }
    // Check dropdown option availability
    const selectOption = productCard.querySelector(`option[value="${variantId}"]`);
    if (selectOption && (selectOption.disabled || selectOption.hasAttribute('data-sold-out'))) {
      return false;
    }
    return true;
  }

  // Check if variant is available
  const isAvailable = checkVariantAvailability(productCard, variantId);
  if (isAvailable) {
    addToCartButton.disabled = false;
    addToCartButton.removeAttribute('aria-disabled');
    addToCartButton.style.opacity = '1';
    addToCartButton.style.cursor = 'pointer';
    addToCartButton.setAttribute('title', 'Add to cart');
    // Only update .btn-text, not any span
    const buttonText = addToCartButton.querySelector('.btn-text');
    if (buttonText) {
      buttonText.textContent = 'Add to cart';
    }
  } else {
    addToCartButton.disabled = true;
    addToCartButton.setAttribute('aria-disabled', 'true');
    addToCartButton.style.opacity = '0.5';
    addToCartButton.style.cursor = 'not-allowed';
    addToCartButton.setAttribute('title', 'Variant not available');
    // Only update .btn-text, not any span
    const buttonText = addToCartButton.querySelector('.btn-text');
    if (buttonText) {
      buttonText.textContent = 'Sold out';
    }
  }
}

// Initialize wishlist buttons
document.addEventListener('DOMContentLoaded', () => {
  const wishlistButtons = document.querySelectorAll('.wishlist-button');
  wishlistButtons.forEach(button => {
    if (!button.initialized && typeof button.initialize === 'function') {
      button.initialized = true;
      button.initialize();
    }
  });
});


